var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleGetGems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 698,
    height: 258,
    viewBox: "0 0 698 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_15376_4082)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 129.104,
    cy: 128.741,
    r: 69.1036,
    fill: "#28FFBB",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.233 144.838L184.259 103.043L175.036 82.8818L172.758 81.8694L150.505 73.727L124.538 64.2272L106.74 73.589L77.6948 151.896L84.2597 172.239L130.752 195.477L151.895 187.45L168.233 144.838Z",
    fill: "#1A9C00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.231 144.838L151.893 187.449L151.35 174.865L168.231 144.838Z",
    fill: "url(#paint0_linear_15376_4082)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.059 103.557L168.231 144.836L175.957 110.31L184.033 103.547L184.059 103.557Z",
    fill: "url(#paint1_linear_15376_4082)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.258 103.041L184.06 103.558L184.033 103.548L175.957 110.31L179.775 93.2451L184.258 103.041Z",
    fill: "url(#paint2_linear_15376_4082)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.351 174.865L142.727 190.203L136.803 180.069L149.519 132.453L151.351 174.865Z",
    fill: "url(#paint3_linear_15376_4082)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.958 110.31L149.519 132.453L169.003 94.6027L179.776 93.2451L175.958 110.31Z",
    fill: "url(#paint4_linear_15376_4082)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.055 194.979L130.751 195.475L84.259 172.237L87.225 172.039L109.543 183.433L109.563 183.483L109.625 183.476L132.029 194.913L132.055 194.979Z",
    fill: "url(#paint5_linear_15376_4082)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.519 132.454L136.803 180.069L109.626 183.477L109.543 183.435L101.259 163.122L149.519 132.454Z",
    fill: "url(#paint6_linear_15376_4082)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M175.035 82.8806L169.002 94.6028L168.751 94.6341L150.504 73.7259L172.757 81.8682L175.035 82.8806Z",
    fill: "url(#paint7_linear_15376_4082)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.002 94.6025L149.518 132.452L131.76 80.3147L150.504 73.7257L168.751 94.6339L169.002 94.6025Z",
    fill: "url(#paint8_linear_15376_4082)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.518 132.453L95.7742 147.432L93.8859 114.509L118.269 88.5625L149.518 132.453Z",
    fill: "url(#paint9_linear_15376_4082)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.625 183.477L109.563 183.484L109.543 183.434L109.625 183.477Z",
    fill: "url(#paint10_linear_15376_4082)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.259 163.121L109.543 183.434L87.225 172.04L101.259 163.121Z",
    fill: "url(#paint11_linear_15376_4082)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.504 73.7262L131.76 80.3153L131.759 80.3145L126.772 65.6735L117.222 70.4552L108.489 74.8278L106.739 73.5882L124.537 64.2264L150.504 73.7262Z",
    fill: "url(#paint12_linear_15376_4082)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.259 163.122L87.225 172.041L83.614 161.673L101.259 163.122Z",
    fill: "url(#paint13_linear_15376_4082)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.772 65.6741L131.759 80.3151L117.223 70.4557L126.772 65.6741Z",
    fill: "url(#paint14_linear_15376_4082)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6135 161.673L87.2244 172.04L84.2584 172.237L77.6935 151.895L80.1665 151.782L83.6135 161.673Z",
    fill: "url(#paint15_linear_15376_4082)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7744 147.431L83.6138 161.673L80.1669 151.781L95.7744 147.431Z",
    fill: "url(#paint16_linear_15376_4082)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.886 114.508L95.7743 147.432L80.1668 151.782L93.886 114.508Z",
    fill: "url(#paint17_linear_15376_4082)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M117.222 70.4553L118.268 88.5623L108.489 74.8279L117.222 70.4553Z",
    fill: "url(#paint18_linear_15376_4082)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M118.268 88.5621L93.8855 114.508L108.489 74.8276L118.268 88.5621Z",
    fill: "url(#paint19_linear_15376_4082)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M136.803 180.069L142.727 190.203L151.351 174.865L151.894 187.449L132.055 194.981L132.03 194.915L109.626 183.477L136.803 180.069Z",
    fill: "url(#paint20_linear_15376_4082)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M175.958 110.311L168.232 144.838L151.351 174.866L149.519 132.454L175.958 110.311Z",
    fill: "url(#paint21_linear_15376_4082)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M175.036 82.8812L179.776 93.2458L169.002 94.6033L175.036 82.8812Z",
    fill: "url(#paint22_linear_15376_4082)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131.761 80.3156L149.519 132.453L118.269 88.5626L117.223 70.4556L131.759 80.3149L131.761 80.3156Z",
    fill: "url(#paint23_linear_15376_4082)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M149.519 132.453L101.259 163.122L83.6142 161.674L95.7748 147.432L149.519 132.453Z",
    fill: "url(#paint24_linear_15376_4082)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8861 114.508L80.1669 151.782L77.6938 151.895L106.739 73.5879L108.489 74.8274L93.8861 114.508Z",
    fill: "url(#paint25_linear_15376_4082)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M131.758 80.3143L126.771 65.6733L117.222 70.455L108.489 74.8275L93.8856 114.508L80.1664 151.782L83.6133 161.673L87.2242 172.04L109.542 183.434L109.625 183.477L132.028 194.914",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M151.893 187.449L151.35 174.865L149.518 132.453L131.76 80.3149",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M184.033 103.548L175.957 110.31L149.519 132.453L101.259 163.121L87.225 172.04L84.2589 172.237",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M106.739 73.5879L108.489 74.8274L118.269 88.5619L149.518 132.453L136.803 180.069L133.098 193.944",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M175.035 82.8807L169.002 94.6028L149.518 132.453L95.7739 147.432L80.1664 151.782L77.6934 151.895",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M131.76 80.315L150.504 73.7259L168.751 94.6342L169.002 94.6028L179.775 93.2452L175.957 110.31L168.232 144.837L151.351 174.865L142.727 190.203L136.803 180.069L109.625 183.476L109.563 183.484L109.542 183.434L101.259 163.121L83.6137 161.673L95.7743 147.432L93.886 114.508L118.269 88.5619L117.222 70.4549L131.759 80.3142L131.76 80.315Z",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M184.258 103.042L151.894 187.449L149.589 187.183L181.826 102.719L184.258 103.042Z",
    fill: "url(#paint26_linear_15376_4082)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M151.894 187.449L130.751 195.477L149.589 187.183L151.894 187.449Z",
    fill: "url(#paint27_linear_15376_4082)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M184.258 103.041L181.826 102.719L172.757 81.8677L175.035 82.8801L184.258 103.041Z",
    fill: "url(#paint28_linear_15376_4082)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M181.826 102.72L172.491 99.1752L167.388 89.1815L172.758 81.8692L181.826 102.72Z",
    fill: "url(#paint29_linear_15376_4082)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M172.49 99.1742L140.183 183.456L130.904 179.788L162.551 95.9694L172.49 99.1742Z",
    fill: "url(#paint30_linear_15376_4082)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M130.596 187.983L130.75 195.476L84.2583 172.238L84.4512 164.302L130.596 187.983Z",
    fill: "url(#paint31_linear_15376_4082)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M172.49 99.174L162.551 95.9692L167.387 89.1803L172.49 99.174Z",
    fill: "url(#paint32_linear_15376_4082)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M130.905 179.788L130.597 187.983L84.4519 164.302L84.0764 157.307L130.905 179.788Z",
    fill: "url(#paint33_linear_15376_4082)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M172.757 81.8684L167.387 89.1807L119.096 70.6722L124.536 64.2262L172.757 81.8684Z",
    fill: "url(#paint34_linear_15376_4082)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M167.388 89.1809L162.552 95.9698L114.161 77.3427L119.097 70.6724L167.388 89.1809Z",
    fill: "url(#paint35_linear_15376_4082)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M84.451 164.302L84.2581 172.237L77.6932 151.895L79.9625 154.286L80.5535 154.72L84.451 164.302Z",
    fill: "url(#paint36_linear_15376_4082)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0766 157.307L84.4522 164.302L80.5546 154.721L84.0766 157.307Z",
    fill: "url(#paint37_linear_15376_4082)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M124.537 64.2258L119.097 70.6718L109.62 75.6269L106.739 73.5876L124.537 64.2258Z",
    fill: "url(#paint38_linear_15376_4082)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M119.097 70.6724L114.161 77.3426L109.62 75.6275L119.097 70.6724Z",
    fill: "url(#paint39_linear_15376_4082)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4693 154.511L80.5541 154.721L79.9631 154.286L77.6938 151.895L106.739 73.5879L109.62 75.6272L80.4693 154.511Z",
    fill: "url(#paint40_linear_15376_4082)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M181.827 102.72L149.59 187.184L140.185 183.457L172.492 99.1755L181.827 102.72Z",
    fill: "url(#paint41_linear_15376_4082)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M149.59 187.183L130.751 195.476L130.597 187.983L140.184 183.456L149.59 187.183Z",
    fill: "url(#paint42_linear_15376_4082)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M140.185 183.458L130.598 187.984L130.906 179.789L140.185 183.458Z",
    fill: "url(#paint43_linear_15376_4082)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M162.553 95.9703L130.906 179.789L84.0774 157.308L114.162 77.3432L162.553 95.9703Z",
    fill: "url(#paint44_linear_15376_4082)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M114.162 77.3427L84.0771 157.307L80.5551 154.721L80.4703 154.511L109.621 75.6276L114.162 77.3427Z",
    fill: "url(#paint45_linear_15376_4082)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M124.536 64.2257L172.757 81.8679L181.826 102.719L149.589 187.183L130.75 195.476L84.2583 172.237L77.6934 151.895L106.738 73.5876L124.536 64.2257Z",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M119.097 70.6728L167.388 89.1813L172.491 99.175L140.184 183.457L130.597 187.984L84.4518 164.303L80.5543 154.721L80.4695 154.512L109.62 75.628L119.097 70.6728Z",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M114.161 77.3427L162.552 95.9699L130.905 179.788L84.0765 157.307L114.161 77.3427Z",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M172.757 81.8684L167.387 89.1807L162.551 95.9695L172.49 99.1744L181.825 102.719L184.258 103.042",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M130.75 195.476L130.596 187.983L130.904 179.788L140.183 183.456L149.588 187.183L151.893 187.448",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2583 172.237L84.4512 164.302L84.0757 157.307L80.5536 154.721L79.9627 154.286L77.6934 151.895",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M106.739 73.5881L109.62 75.6274L114.161 77.3425L119.097 70.6723L124.537 64.2263",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M130.75 195.476L151.894 187.448L184.258 103.041L175.035 82.8806L172.757 81.8682",
    stroke: "white",
    strokeWidth: 0.31219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M260.746 164.529C259.955 165.496 258.871 166.478 257.494 167.474C256.117 168.47 254.491 169.363 252.616 170.154C250.712 170.975 248.588 171.634 246.244 172.132C243.9 172.63 241.381 172.879 238.686 172.879C236.342 172.879 234.13 172.601 232.05 172.044C229.999 171.517 228.109 170.74 226.381 169.715C224.682 168.66 223.129 167.371 221.723 165.848C220.346 164.324 219.174 162.581 218.207 160.618C217.094 158.45 216.244 156.004 215.658 153.279C215.102 150.555 214.823 147.596 214.823 144.402V135.701C214.823 132.654 215.102 129.827 215.658 127.22C216.215 124.583 217.006 122.195 218.031 120.057C218.998 118.152 220.111 116.438 221.371 114.915C222.66 113.392 224.066 112.073 225.59 110.96C227.377 109.7 229.325 108.748 231.435 108.104C233.544 107.459 235.771 107.137 238.114 107.137C241.718 107.137 244.853 107.591 247.519 108.499C250.214 109.407 252.484 110.711 254.33 112.41C256.176 114.139 257.611 116.233 258.637 118.694C259.691 121.155 260.38 123.924 260.702 127H248.661C248.456 125.447 248.134 124.07 247.694 122.869C247.284 121.668 246.713 120.657 245.98 119.837C245.16 118.929 244.12 118.255 242.86 117.815C241.63 117.347 240.15 117.112 238.422 117.112C237.484 117.112 236.576 117.259 235.697 117.552C234.818 117.845 233.998 118.27 233.236 118.826C232.24 119.588 231.332 120.584 230.512 121.814C229.721 123.045 229.062 124.495 228.534 126.165C228.124 127.454 227.802 128.89 227.567 130.472C227.362 132.054 227.26 133.768 227.26 135.613V144.402C227.26 146.717 227.406 148.826 227.699 150.73C228.021 152.635 228.461 154.319 229.018 155.784C229.369 156.634 229.765 157.425 230.204 158.157C230.673 158.86 231.186 159.49 231.742 160.047C232.68 160.984 233.764 161.702 234.994 162.2C236.254 162.669 237.675 162.918 239.257 162.947C240.224 162.947 241.176 162.874 242.113 162.728C243.051 162.581 243.93 162.376 244.75 162.112C245.57 161.849 246.288 161.556 246.903 161.233C247.548 160.882 248.031 160.516 248.354 160.135L248.397 148.533H237.807V139.305H260.702L260.746 164.529ZM294.32 172.879C290.658 172.879 287.333 172.278 284.345 171.077C281.356 169.876 278.793 168.235 276.654 166.155C274.516 164.104 272.86 161.688 271.688 158.904C270.546 156.092 269.975 153.089 269.975 149.896V148.138C269.975 144.505 270.546 141.194 271.688 138.206C272.831 135.188 274.428 132.596 276.479 130.428C278.529 128.26 280.961 126.575 283.773 125.374C286.586 124.173 289.647 123.572 292.958 123.572C296.386 123.572 299.433 124.144 302.099 125.286C304.794 126.399 307.079 127.981 308.954 130.032C310.8 132.083 312.206 134.559 313.173 137.459C314.14 140.33 314.623 143.509 314.623 146.995V152.181H282.367V152.312C282.777 154.217 283.305 155.755 283.949 156.927C284.594 158.069 285.458 159.109 286.542 160.047C287.655 161.014 288.93 161.761 290.365 162.288C291.801 162.815 293.368 163.079 295.067 163.079C297.47 163.079 299.799 162.625 302.055 161.717C304.311 160.809 306.142 159.446 307.548 157.63L313.656 164.222C312.104 166.419 309.643 168.411 306.273 170.198C302.904 171.985 298.92 172.879 294.32 172.879ZM292.87 133.46C291.493 133.46 290.233 133.709 289.091 134.207C287.948 134.676 286.952 135.364 286.103 136.272C285.224 137.181 284.491 138.265 283.905 139.524C283.319 140.784 282.88 142.19 282.587 143.743H302.626V142.776C302.626 141.487 302.392 140.271 301.923 139.129C301.454 137.986 300.81 136.99 299.989 136.141C299.169 135.32 298.158 134.676 296.957 134.207C295.785 133.709 294.423 133.46 292.87 133.46ZM347.714 112.806V124.451H365.468V133.46H347.714V153.895C347.714 155.623 347.904 157.073 348.285 158.245C348.695 159.388 349.267 160.296 349.999 160.97C350.731 161.673 351.61 162.171 352.636 162.464C353.69 162.757 354.862 162.903 356.151 162.903C357.089 162.903 358.041 162.859 359.008 162.771C360.004 162.684 360.956 162.566 361.864 162.42C362.743 162.303 363.563 162.171 364.325 162.024C365.116 161.878 365.79 161.731 366.347 161.585L367.533 169.979C366.684 170.477 365.688 170.916 364.545 171.297C363.402 171.648 362.187 171.941 360.897 172.176C359.608 172.41 358.261 172.586 356.854 172.703C355.478 172.85 354.115 172.923 352.768 172.923C350.16 172.923 347.787 172.586 345.648 171.912C343.539 171.209 341.737 170.125 340.243 168.66C338.72 167.225 337.548 165.394 336.728 163.167C335.907 160.911 335.497 158.216 335.497 155.081V133.46H324.643V124.451H335.497V112.806H347.714Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M465.136 155.213C465.136 153.982 464.945 152.898 464.564 151.961C464.213 150.994 463.642 150.115 462.851 149.324C462.03 148.533 460.961 147.815 459.643 147.171C458.354 146.497 456.786 145.838 454.94 145.193C451.981 144.139 449.286 143.025 446.854 141.854C444.423 140.682 442.357 139.319 440.658 137.767C438.93 136.214 437.597 134.412 436.659 132.361C435.722 130.281 435.253 127.82 435.253 124.979C435.253 122.488 435.678 120.218 436.527 118.167C437.377 116.087 438.578 114.285 440.131 112.762C441.684 111.238 443.559 110.008 445.756 109.07C447.953 108.133 450.399 107.532 453.095 107.269V97.8203H460.126V107.356C462.763 107.708 465.136 108.426 467.245 109.51C469.354 110.594 471.156 112 472.65 113.729C474.115 115.486 475.243 117.552 476.034 119.925C476.854 122.269 477.265 124.905 477.265 127.835H465.048C465.048 125.96 464.813 124.319 464.345 122.913C463.876 121.507 463.217 120.35 462.367 119.441C461.605 118.65 460.683 118.05 459.599 117.64C458.544 117.229 457.372 117.024 456.083 117.024C454.589 117.024 453.285 117.229 452.172 117.64C451.088 118.021 450.194 118.562 449.491 119.266C448.788 119.998 448.261 120.848 447.909 121.814C447.587 122.781 447.426 123.836 447.426 124.979C447.426 126.121 447.587 127.146 447.909 128.055C448.261 128.934 448.847 129.754 449.667 130.516C450.458 131.277 451.513 132.01 452.831 132.713C454.149 133.387 455.79 134.075 457.753 134.778C460.712 135.892 463.393 137.049 465.795 138.25C468.197 139.422 470.263 140.784 471.991 142.337C473.69 143.919 474.994 145.75 475.902 147.83C476.84 149.881 477.309 152.312 477.309 155.125C477.309 157.703 476.884 160.032 476.034 162.112C475.185 164.163 473.969 165.936 472.387 167.43C470.805 168.924 468.9 170.125 466.674 171.033C464.447 171.912 461.957 172.483 459.203 172.747V181.36H452.216V172.747C449.726 172.513 447.309 171.971 444.965 171.121C442.621 170.242 440.556 168.982 438.769 167.342C436.952 165.701 435.502 163.636 434.418 161.146C433.334 158.626 432.792 155.608 432.792 152.093H445.053C445.053 154.202 445.36 155.975 445.976 157.41C446.591 158.816 447.396 159.93 448.393 160.75C449.359 161.6 450.473 162.2 451.732 162.552C452.992 162.903 454.281 163.079 455.6 163.079C457.27 163.079 458.72 162.874 459.95 162.464C461.181 162.024 462.191 161.424 462.982 160.662C463.686 159.988 464.213 159.183 464.564 158.245C464.945 157.308 465.136 156.297 465.136 155.213ZM531.01 164.529C530.219 165.496 529.135 166.478 527.758 167.474C526.381 168.47 524.755 169.363 522.88 170.154C520.976 170.975 518.852 171.634 516.508 172.132C514.164 172.63 511.645 172.879 508.949 172.879C506.605 172.879 504.394 172.601 502.313 172.044C500.263 171.517 498.373 170.74 496.645 169.715C494.945 168.66 493.393 167.371 491.986 165.848C490.609 164.324 489.438 162.581 488.471 160.618C487.357 158.45 486.508 156.004 485.922 153.279C485.365 150.555 485.087 147.596 485.087 144.402V135.701C485.087 132.654 485.365 129.827 485.922 127.22C486.479 124.583 487.27 122.195 488.295 120.057C489.262 118.152 490.375 116.438 491.635 114.915C492.924 113.392 494.33 112.073 495.854 110.96C497.641 109.7 499.589 108.748 501.698 108.104C503.808 107.459 506.034 107.137 508.378 107.137C511.981 107.137 515.116 107.591 517.782 108.499C520.478 109.407 522.748 110.711 524.594 112.41C526.439 114.139 527.875 116.233 528.9 118.694C529.955 121.155 530.644 123.924 530.966 127H518.925C518.72 125.447 518.397 124.07 517.958 122.869C517.548 121.668 516.977 120.657 516.244 119.837C515.424 118.929 514.384 118.255 513.124 117.815C511.894 117.347 510.414 117.112 508.686 117.112C507.748 117.112 506.84 117.259 505.961 117.552C505.082 117.845 504.262 118.27 503.5 118.826C502.504 119.588 501.596 120.584 500.775 121.814C499.984 123.045 499.325 124.495 498.798 126.165C498.388 127.454 498.065 128.89 497.831 130.472C497.626 132.054 497.523 133.768 497.523 135.613V144.402C497.523 146.717 497.67 148.826 497.963 150.73C498.285 152.635 498.725 154.319 499.281 155.784C499.633 156.634 500.028 157.425 500.468 158.157C500.937 158.86 501.449 159.49 502.006 160.047C502.943 160.984 504.027 161.702 505.258 162.2C506.518 162.669 507.938 162.918 509.521 162.947C510.487 162.947 511.439 162.874 512.377 162.728C513.314 162.581 514.193 162.376 515.014 162.112C515.834 161.849 516.552 161.556 517.167 161.233C517.812 160.882 518.295 160.516 518.617 160.135L518.661 148.533H508.07V139.305H530.966L531.01 164.529ZM580.448 143.963H554.169V162.024H584.887V172H541.776V108.016H584.755V118.079H554.169V134.207H580.448V143.963ZM610.287 108.016L616.352 132.054L623.251 108.016H638.588V172H627.25V153.06L627.777 123.133L619.384 150.906H613.275L605.761 124.319L606.288 153.06V172H594.95V108.016H610.287ZM682.401 155.301C682.401 154.158 682.196 153.089 681.786 152.093C681.405 151.097 680.746 150.159 679.809 149.28C678.842 148.431 677.582 147.654 676.029 146.951C674.506 146.219 672.602 145.545 670.316 144.93C666.771 143.963 663.651 142.791 660.956 141.414C658.29 140.037 656.107 138.528 654.408 136.888C652.709 135.247 651.42 133.431 650.541 131.438C649.691 129.446 649.267 127.278 649.267 124.935C649.267 122.239 649.838 119.793 650.98 117.596C652.123 115.398 653.705 113.523 655.727 111.971C657.748 110.418 660.136 109.231 662.89 108.411C665.644 107.562 668.632 107.137 671.854 107.137C675.194 107.137 678.241 107.62 680.995 108.587C683.778 109.554 686.166 110.901 688.158 112.63C690.15 114.388 691.703 116.468 692.816 118.87C693.93 121.272 694.486 123.909 694.486 126.78H682.445C682.387 125.345 682.123 124.026 681.654 122.825C681.215 121.624 680.556 120.584 679.677 119.705C678.769 118.855 677.641 118.196 676.293 117.728C674.975 117.229 673.422 116.98 671.635 116.98C669.994 116.98 668.529 117.186 667.24 117.596C665.98 117.977 664.911 118.519 664.032 119.222C663.153 119.954 662.479 120.818 662.011 121.814C661.571 122.781 661.352 123.836 661.352 124.979C661.352 126.18 661.645 127.264 662.23 128.23C662.846 129.197 663.725 130.062 664.867 130.823C666.01 131.614 667.387 132.332 668.998 132.977C670.639 133.621 672.484 134.222 674.535 134.778C676.732 135.394 678.827 136.141 680.819 137.02C682.812 137.898 684.643 138.909 686.312 140.052C688.832 141.927 690.839 144.109 692.333 146.6C693.827 149.09 694.574 151.961 694.574 155.213C694.574 158.025 694.003 160.53 692.86 162.728C691.747 164.896 690.194 166.727 688.202 168.221C686.21 169.744 683.837 170.901 681.083 171.692C678.329 172.454 675.326 172.835 672.074 172.835C668.881 172.835 665.717 172.366 662.582 171.429C659.477 170.462 656.767 169.056 654.452 167.21C652.255 165.394 650.512 163.255 649.223 160.794C647.963 158.333 647.333 155.447 647.333 152.137H659.462C659.521 154.07 659.857 155.726 660.473 157.103C661.088 158.479 661.952 159.607 663.065 160.486C664.149 161.365 665.453 162.01 666.977 162.42C668.529 162.83 670.229 163.035 672.074 163.035C673.715 163.035 675.165 162.845 676.425 162.464C677.714 162.083 678.798 161.556 679.677 160.882C680.556 160.208 681.229 159.402 681.698 158.465C682.167 157.498 682.401 156.443 682.401 155.301Z",
    fill: "#28FFBB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_15376_4082",
    x: 0.817284,
    y: 0.454491,
    width: 256.573,
    height: 256.572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.5914,
    result: "effect1_foregroundBlur_15376_4082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15376_4082",
    x1: 163.131,
    y1: 153.03,
    x2: 155.417,
    y2: 171.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15376_4082",
    x1: 171.646,
    y1: 134.197,
    x2: 177.57,
    y2: 114.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15376_4082",
    x1: 171.547,
    y1: 111.217,
    x2: 179.663,
    y2: 101.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15376_4082",
    x1: 143.929,
    y1: 199.914,
    x2: 144.24,
    y2: 152.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15376_4082",
    x1: 179.547,
    y1: 100.003,
    x2: 152.609,
    y2: 117.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15376_4082",
    x1: 84.0623,
    y1: 172.679,
    x2: 132.415,
    y2: 194.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15376_4082",
    x1: 120.138,
    y1: 170.275,
    x2: 144.917,
    y2: 140.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15376_4082",
    x1: 157.915,
    y1: 89.5559,
    x2: 168.992,
    y2: 63.8807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15376_4082",
    x1: 150.55,
    y1: 86.3682,
    x2: 144.871,
    y2: 123.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_15376_4082",
    x1: 99.723,
    y1: 114.244,
    x2: 123.545,
    y2: 126.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_15376_4082",
    x1: 109.535,
    y1: 183.45,
    x2: 109.62,
    y2: 183.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_15376_4082",
    x1: 105.334,
    y1: 159.375,
    x2: 91.9726,
    y2: 194.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_15376_4082",
    x1: 135.484,
    y1: 95.3785,
    x2: 122.771,
    y2: 55.1409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_15376_4082",
    x1: 100.208,
    y1: 158.971,
    x2: 86.2611,
    y2: 166.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_15376_4082",
    x1: 118.267,
    y1: 68.1061,
    x2: 134.065,
    y2: 75.1275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_15376_4082",
    x1: 89.3771,
    y1: 158.507,
    x2: 83.3905,
    y2: 161.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_15376_4082",
    x1: 95.9252,
    y1: 149.992,
    x2: 79.0137,
    y2: 158.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_15376_4082",
    x1: 85.8376,
    y1: 132.617,
    x2: 99.6337,
    y2: 138.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_15376_4082",
    x1: 108.278,
    y1: 75.3014,
    x2: 121.542,
    y2: 81.1965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_15376_4082",
    x1: 99.9209,
    y1: 94.1052,
    x2: 113.185,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_15376_4082",
    x1: 143.284,
    y1: 223.317,
    x2: 127.792,
    y2: 169.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_15376_4082",
    x1: 184.308,
    y1: 150.72,
    x2: 144.964,
    y2: 135.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_15376_4082",
    x1: 152.442,
    y1: 103.631,
    x2: 183.268,
    y2: 84.4069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_15376_4082",
    x1: 88.5275,
    y1: 28.2046,
    x2: 142.806,
    y2: 111.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_15376_4082",
    x1: 61.1588,
    y1: 173.107,
    x2: 128.273,
    y2: 141.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_15376_4082",
    x1: 89.812,
    y1: 111.673,
    x2: 96.6439,
    y2: 114.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_15376_4082",
    x1: 172.109,
    y1: 146.823,
    x2: 167.757,
    y2: 145.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_15376_4082",
    x1: 133.984,
    y1: 188.202,
    x2: 148.66,
    y2: 194.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_15376_4082",
    x1: 189.56,
    y1: 90.6849,
    x2: 178.282,
    y2: 92.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_15376_4082",
    x1: 179.821,
    y1: 106.608,
    x2: 170.24,
    y2: 85.8873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_15376_4082",
    x1: 169.641,
    y1: 93.6842,
    x2: 141.808,
    y2: 163.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_15376_4082",
    x1: 64.312,
    y1: 158.038,
    x2: 124.762,
    y2: 188.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_15376_4082",
    x1: 174.981,
    y1: 93.1324,
    x2: 166.558,
    y2: 94.8775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_15376_4082",
    x1: 137.724,
    y1: 185.136,
    x2: 87.9519,
    y2: 164.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_15376_4082",
    x1: 134.418,
    y1: 73.0236,
    x2: 166.171,
    y2: 83.1453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_15376_4082",
    x1: 173.442,
    y1: 93.815,
    x2: 130.087,
    y2: 79.8666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_15376_4082",
    x1: 74.4601,
    y1: 159.169,
    x2: 87.492,
    y2: 164.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_15376_4082",
    x1: 87.389,
    y1: 157.461,
    x2: 84.1173,
    y2: 158.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_15376_4082",
    x1: 120.608,
    y1: 76.3962,
    x2: 117.322,
    y2: 71.4436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_15376_4082",
    x1: 115.869,
    y1: 78.2817,
    x2: 113.617,
    y2: 70.6302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_15376_4082",
    x1: 64.7028,
    y1: 169.707,
    x2: 91.8583,
    y2: 117.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_15376_4082",
    x1: 197.81,
    y1: 155.567,
    x2: 148.346,
    y2: 138.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_15376_4082",
    x1: 161.846,
    y1: 220.409,
    x2: 136.637,
    y2: 186.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_15376_4082",
    x1: 125.793,
    y1: 165.608,
    x2: 136.47,
    y2: 187.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_15376_4082",
    x1: 57.2104,
    y1: 181.645,
    x2: 169.655,
    y2: 90.2768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_15376_4082",
    x1: 136.906,
    y1: 122.674,
    x2: 92.102,
    y2: 115.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleGetGems);
export default __webpack_public_path__ + "static/media/title-get-gems.2fcbf65aecc0df4bb61815c865384e85.svg";
export { ForwardRef as ReactComponent };